"use client";

import { useTheme } from "@mui/material/styles";

export function ArrowIcon() {
  const theme = useTheme();
  const iconColor = theme.palette.mode === 'dark' ? '#F2F2F2' : '#2D3135';
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.58151 8.30797C3.57767 8.71565 3.65426 10.1617 4.69559 10.4611L9.95001 11.9715L12.3498 16.8838C12.8255 17.8573 14.2629 17.6817 14.4901 16.6223L16.9364 5.2137C17.1284 4.31835 16.2403 3.57315 15.3919 3.9177L4.58151 8.30797Z"
        fill={iconColor}
      />
    </svg>
  );
}

export function StackIcon() {
  const theme = useTheme();
  const iconColor = theme.palette.mode === 'dark' ? '#F2F2F2' : '#2D3135';
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_10891_3806)">
        <mask
          id="mask0_10891_3806"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20">
          <path d="M20 0H0V20H20V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_10891_3806)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.70781 9.43342C1.29271 8.53283 1.29271 6.46712 2.70782 5.56661L7.8753 2.2782C9.17189 1.45308 10.829 1.45308 12.1256 2.27821L17.2931 5.56661C18.7081 6.46713 18.7081 8.53283 17.2931 9.43342L12.1256 12.7218C10.829 13.5469 9.17189 13.5469 7.8753 12.7218L2.70781 9.43342Z"
            fill={iconColor}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3844 9.98832L12.1255 7.27817C10.829 6.45306 9.17195 6.45305 7.8753 7.27817L3.61648 9.98832L8.54637 13.1256C9.43354 13.6901 10.5673 13.6901 11.4545 13.1256L16.3844 9.98832ZM17.5184 10.7292C17.4477 10.7867 17.3726 10.8411 17.293 10.8917L12.1255 14.1802C10.829 15.0052 9.17187 15.0052 7.87528 14.1802L2.70779 10.8917C2.62821 10.8411 2.55311 10.7867 2.48248 10.7292C1.29718 11.6957 1.37229 13.5835 2.70781 14.4333L7.8753 17.7217C9.17195 18.5469 10.829 18.5469 12.1255 17.7217L17.293 14.4333C18.6286 13.5835 18.7037 11.6957 17.5184 10.7292Z"
            fill={iconColor}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_10891_3806">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ExchangeIcon() {
  const theme = useTheme();
  const iconColor = theme.palette.mode === 'dark' ? '#F2F2F2' : '#2D3135';
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.5 8.33334C2.5 5.00001 4.16667 3.33334 7.5 3.33334"
        stroke={iconColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.666 12.5C16.666 15.8333 14.9993 17.5 11.666 17.5"
        stroke={iconColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.666 7.50001C11.666 5.19884 13.5315 3.33334 15.8327 3.33334H17.4993V9.16668H11.666V7.50001Z"
        fill={iconColor}
        stroke={iconColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 11.6667H8.33333V13.3333C8.33333 15.6345 6.46783 17.5 4.16667 17.5H2.5V11.6667Z"
        fill={iconColor}
        stroke={iconColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
